import React from 'react'
import FeatureMain from '../../../../components/Features/FeatureMain/FeatureMain'
import { ProjectBranch } from '../../../../components/Features/projectBranch'
import { pageData } from './pageData'

export default function Ego20261109Feature({
    projectBranch,
}: {
    projectBranch: ProjectBranch
}) {
    return <FeatureMain {...pageData} projectBranch={projectBranch} />
}
